import { PolymerElement, html } from '@polymer/polymer';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import '@wdpr/avenir-typography';
import '@wdpr/color';
import '@wdpr/mdx-icons';

import './style/wdpr-counter-style.js';

class WdprCounter extends mixinBehaviors([GestureEventListeners], PolymerElement) {

  static get is() {
    return 'wdpr-counter';
  }

  static get template() {
    return html`

        <!-- Scoped styles for this element -->
        <style include="wdpr-avenir-typography"></style>
        <style include="wdpr-color"></style>
        <style include="wdpr-mdx-icons"></style>
        <style include="wdpr-counter-style"></style>

        <div class="wdpr-counter">

            <!-- Decrement button -->
            <button id="minusButton" class="decrement button" aria-label\$="[[ariaDecrement]]" aria-hidden\$="[[_isAriaLabelHidden(valueOnly)]]" title="[[minusAlt]]" on-click="_decrement" on-touchstart="_decrement" on-keyup="_addOutline" on-blur="_removeOutline" disabled\$="[[_isDisabled(value, lowerLimit, disabled, minusDisabled)]]">
                <!-- Remove when new MDX icon library is available -->
                <svg class="icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="minus" transform="translate(6.000000, 11.000000)">
                            <rect id="Rectangle-21" x="0" y="0" width="12" height="2" rx="1"></rect>
                        </g>
                    </g>
                </svg>
            </button>

            <!-- Non editable counter -->
            <span class="counter non-editable" id="nonEditableCounter" title="[[counterAlt]]" aria-label\$="[[_ariaLabelCounter()]]" aria-hidden\$="[[_isAriaHidden(ariaHiddenCounter)]]" on-keyup="_addOutline" on-blur="_removeOutline" hidden\$="[[editable]]">{{value}}</span>

            <!-- Editable counter -->
            <div id="editableWrapper" hidden\$="[[!editable]]" aria-label="">
                <span title="[[counterAlt]]">
                    <input id="editableInput" type="text" on-keydown="_onKeydown" class="counter" value="{{value::change}}" disabled\$="{{disabled}}" aria-label\$="quantity input field. lower limit [[lowerLimit]] upper limit [[upperLimit]]">
                </span>
                <!--button update message-->
            </div>

            <span class="visually-hidden" id="alert" aria-live="assertive" aria-atomic="true" role="alert">
            </span>
            

            <!-- Increment button -->
            <button id="plusButton" class="increment button" aria-label\$="[[ariaIncrement]]" title="[[plusAlt]]" aria-hidden\$="[[_isAriaLabelHidden(valueOnly)]]" on-click="_increment" on-touchstart="_increment" on-keyup="_addOutline" on-blur="_removeOutline" disabled\$="[[_isDisabled(value, upperLimit, disabled, plusDisabled)]]">
                <!-- Remove when new MDX icon library is available -->
                <svg class="icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="plus" transform="translate(6.000000, 6.000000)">
                            <g>
                                <rect id="Rectangle-18" x="0" y="5" width="12" height="2" rx="1"></rect>
                                <path d="M1,5 L11,5 C11.5522847,5 12,5.44771525 12,6 C12,6.55228475 11.5522847,7 11,7 L1,7 C0.44771525,7 6.76353751e-17,6.55228475 0,6 C-6.76353751e-17,5.44771525 0.44771525,5 1,5 Z" id="Rectangle-19" transform="translate(6.000000, 6.000000) rotate(-270.000000) translate(-6.000000, -6.000000) "></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </button>
            
        </div>
        <input type="hidden" id="[[fieldName]]" name="[[fieldName]]" value="{{value}}">
        `;
  }

  static get properties() {
    return {
      /**
       * Default value
       *
       * @type Number
       */
      value: {
        type: Number,
        value: 0,
        reflectToAttribute: true,
        notify: true,
        observer: '_countChanged'
      },

      /**
      * minus hover title
      *
      * @type String
      */
      minusAlt: {
        type: String
      },

      /**
       * plus hover title
       *
       * @type String
       */
      plusAlt: {
        type: String
      },

      /**
       * counter hover title
       *
       * @type String
       */
      counterAlt: {
        type: String
      },

      /**
       * HTML inpt name and id
       *
       * @type String
       */
      fieldName: {
        type: String
      },

      /**
       * To put Aria hidden of the non-editable counter text
       *
       * @type Boolean
       */
      ariaHiddenCounter: {
        type: Boolean,
        value: false
      },

      /**
       * Aria label for the increment button
       *
       * @type String
       */
      ariaIncrement: {
        type: String,
        value: 'quantity button press to add one item'
      },

      /**
       * Aria label for the decrement button
       *
       * @type String
       */
      ariaDecrement: {
        type: String,
        value: 'quantity button press to remove one item'
      },

      /**
       * Lower limit for the counter
       *
       * @type Number
       */
      lowerLimit: {
        type: Number,
        value: 0
      },

      /**
       * Upper limit for the counter
       *
       * @type Number
       */
      upperLimit: {
        type: Number,
        value: 10
      },
      /**
       * Disabled State
       *
       * @type Boolean
       */
      disabled: {
        type: Boolean,
        value: false
      },
      /**
       * Disabled State for minus btn
       * @type Boolean
       */
      minusDisabled: {
        type: Boolean,
        value: false,
      },
      /**
       * Disabled State for plus btn
       * @type Boolean
       */
      plusDisabled: {
        type: Boolean,
        value: false
      },
      /**
       * Editable
       * @type {Boolean}
       */
      editable: {
        type: Boolean,
        value: false
      },
      /**
       * just diplay the number / input
       * @type {Boolean}
       */
      valueOnly: {
        reflectToAttribute: true,
        type: Boolean,
        value: false
      },
    };
  }

  /**
   * @desc hander to dynamically reject non-numeric keys in editable counter
   * @param {Event} event
   */
  _onKeydown(event) {
    //backspace, tab, supr, left-right and up/down arrows
    let acceptedKeys = [8, 9, 46, 37, 38, 39, 40];
    let pressedKey = event.which || event.keyCode;

    //Numeric event codes for number keys and numpad ones
    let isNumber = pressedKey >= 48 &&
      pressedKey <= 57 ||
      pressedKey >= 96 &&
      pressedKey <= 105;

    //if arrow up key is pressed and the plus button is enabled
    if (pressedKey === 38 && !this.plusDisabled) {
      this.value += 1;
    } else if (pressedKey === 40) {
      this.value -= 1;
    }

    //if the key is not a number and not in the accepted keys array,
    //or is a number pressed with shift key, (except shift+tab) reject
    let neitherNumberNorAcceptedKey = !isNumber && acceptedKeys.indexOf(pressedKey) === -1;
    if (neitherNumberNorAcceptedKey || (event.shiftKey && pressedKey !== 9)) {
      event.returnValue = false;
      event.preventDefault();
    }
  }

  /**
   * @desc add outline triggered by keypress
   * @param {Event} event
   */
  _addOutline(event) {
    event.currentTarget.classList.add('focus');
  }

  /**
   * @desc remove outline triggered by blur
   * @param {Event} event
   */
  _removeOutline(event) {
    event.currentTarget.classList.remove('focus');
  }

  /**
   * Increment the counter
   */
  _increment(event) {
    this.value += 1;
    event.preventDefault();
  }

  /**
   * Decrement the counter
   */
  _decrement(event) {
    this.value -= 1;
    event.preventDefault();
  }

  /**
   * Event triggered when the count updates
   * @param  {[String]} newVal
   * @param  {[String]} oldVal
   */
  _countChanged(newVal, oldVal) {
    if (typeof oldVal === 'undefined') {
      return
    }

    if (newVal > oldVal) {
      if (this.value < this.upperLimit) {
        this.value = Number(this.value);
      } else {
        this.value = this.upperLimit;
        this._counterFocus();
      }
    } else if (newVal < oldVal) {
      if (this.value > this.lowerLimit) {
        this.value = Number(this.value);
      } else {
        this.value = this.lowerLimit;
        this._counterFocus();
      }
    }
    if (newVal !== oldVal) {
        //Fire aria-alert for new value
        this.$.alert.innerHTML="quantity "+this.value;

        //Check if minus button has become enabled/disabled
        if(this.$.minusButton.disabled!=this._isDisabled(oldVal, this.lowerLimit, this.disabled, this.minusDisabled))
        {
            this.$.alert.innerHTML += ". minus button is "+ (this.$.minusButton.disabled? "disabled" : "enabled");
        }

        //Check if plus button has become enabled/disabled
        if(this.$.plusButton.disabled!=this._isDisabled(oldVal, this.upperLimit, this.disabled, this.plusDisabled))
        {
            this.$.alert.innerHTML += ". plus button is "+ (this.$.plusButton.disabled? "disabled": "enabled");
        }
        this._dispatch();
    }
  }

  /**
   * Focus on the counter
   */
  _counterFocus() {
    if (this.editable) {
      this.$.editableInput.focus();
    }
    else if(!this.$.minusButton.disabled && this.value>=this.upperLimit)
    {
        //when max value is reached, focus order becomes distorted
        //remove focus from component by focusing and blurring minus button
        this.$.minusButton.focus();
        this.$.minusButton.blur();
    }
  }

  /* Disables the buttons
  * @param  {Int}  value = current value
  * @param  {Int}  limit = limit passed in
  * @param  {Boolean} isDisabled property
  * @param  {Boolean} individualDisabled
  * @return {Boolean} result of the comparator
  */
  _isDisabled(value, limit, disabled, individualDisabled) {
    return individualDisabled || value === limit || disabled;
  }

  /**
   * Determine if the aria labels should be hidden
   * @param  {Boolean} valueOnly
   * @return {[String]}
   */
  _isAriaLabelHidden(valueOnly) {
    return valueOnly ? 'true' : 'false';
  }

  /**
   * Determine if the aria label for non-editable counter should be hidden
   * @return {[String]}
   */
  _ariaLabelCounter() {
      return this.ariaHiddenCounter ? false : this.value;
  }

  /**
   * Determine if the aria hidden should be true/false
   * @param  {Boolean} ariaHiddenCounter
   * @return {[String]}
   */
  _isAriaHidden(ariaHiddenCounter) {
    return ariaHiddenCounter ? 'true' : 'false';
  }

  _dispatch() {
    this.dispatchEvent(new CustomEvent(WdprCounter.is + '.updated', {
      bubbles: false,
      composed: true,
      detail: {
        value: this.value,
        fieldName: this.fieldName,
        id: this.id
      }
    }));
  }
}

window.customElements.define(WdprCounter.is, WdprCounter);


